import { SmartNewsCardPage } from '../../../Components';
import './NewsSec.css';

const NewsSec = () => {


    return (
        <div className='news-section'>
            <ul className="all-news">
                <SmartNewsCardPage />
            </ul>
        </div>
    );
};

export default NewsSec;
